import * as types from './types';
import { sortCredits } from '../../helpers/utils';

const initialState = {
  loading: true,
  fetchCreditsError: false,
  credits: {},
  isInvalid: false,
  publicationPlans: {},
  loadingPlans: false,
  plansError: false
};

/**
 * La función agrega el atributo de checked=true al plan seleccionado por el usuario.
 * @param {object} credits
 * @param {number} publicationPlanId
 * @param {number} branchId
 * @returns {object} devuelve el objeto actualizado (con el atributo de checked en el plan seleccionado)
 */
const updateSelectedCredit = (credits, publicationPlanId, branchId) => {
  // Se copian los créditos para no mutar el objeto original:
  const updatedCredits = { ...credits };
  // Si el branchId es 'global', se actualizan los globalCredits:
  if (branchId === 'global') {
    updatedCredits.globalCredits.creditItems = updatedCredits.globalCredits.creditItems.map(c => ({
      ...c,
      checked: c.publicationPlanId === publicationPlanId
    }));
  } else {
    // Se escuentra el branch correspondiente por branchId:
    const branch = updatedCredits.branchCredits.find(b => parseInt(b.branchId) === branchId);
    if (branch) {
      // Se actualizan los creditItems del branch correspondiente:
      branch.creditItems = branch.creditItems.map(c => ({
        ...c,
        checked: c.publicationPlanId === publicationPlanId
      }));
    }
  }
  return updatedCredits;
};

function creditsReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CREDITS:
      return { ...state, loading: true };

    case types.FETCH_CREDITS_COMPLETED:
      return {
        ...state,
        loading: false,
        fetchCreditsError: false,
        credits: sortCredits(action.payload),
        hasGlobalCredits: action.payload.globalCredits !== null,
        isInvalid: false
      };

    case types.FETCH_CREDITS_FAILED:
      return { ...state, loading: false, fetchCreditsError: true, isInvalid: false };

    case types.INVALIDATE_CREDITS:
      return { ...state, isInvalid: true };
    case types.SELECT_CREDIT:
      return {
        ...state,
        credits: updateSelectedCredit(state.credits, action.payload.publicationPlanId, action.payload.branchId)
      };
    case types.PUBLICATION_PLANS:
      return { ...state, loadingPlans: true, plansError: false };

    case types.PUBLICATION_PLANS_COMPLETED:
      return {
        ...state,
        loadingPlans: false,
        // armo el obj de publicationPlans con keys que hacen ref al tipo de operacion
        publicationPlans: { [action.payload.operation_type_id]: action.payload.publication_plans }
      };

    case types.PUBLICATION_PLANS_FAILED:
      return { ...state, loadingPlans: false, plansError: true };

    default:
      return state;
  }
}

export default creditsReducer;
